import { useTranslation } from "react-i18next";
import { MapPin, ShieldCheck, ShieldAlert } from "lucide-react";

export const GeoBadge = ({ geo, loading, error }) => {
  const { t } = useTranslation();
  if (loading) return <Pill icon={MapPin} tone="muted" text={t("check.locating")} />;
  if (error) return <Pill icon={ShieldAlert} tone="danger" text={t(`check.${error}`)} />;
  if (!geo) return null;
  return (
    <Pill
      icon={geo.inside ? ShieldCheck : ShieldAlert}
      tone={geo.inside ? "ok" : "danger"}
      text={`${geo.inside ? t("check.inside") : t("check.outside")} · ${t("check.distance")}: ${geo.distance_m} ${t(
        "app.meters"
      )} / ${geo.radius_m} ${t("app.meters")}`}
    />
  );
};

const TONES = {
  ok: "text-success border-success/40",
  danger: "text-destructive border-destructive/40",
  muted: "text-muted-foreground border-border/60",
};

const Pill = ({ icon: Icon, tone, text }) => (
  <div
    data-testid="geo-badge"
    className={`inline-flex items-center gap-2 rounded-full border bg-background px-4 py-2 text-sm font-semibold shadow-neu-sm ${TONES[tone]}`}
  >
    <Icon className="h-4 w-4" />
    <span>{text}</span>
  </div>
);
